/**
 * CSV export of the accounts list as filtered: one row per account with its main contact, so a
 * view ("At risk in Tampa", "Onboarding past day 30") doubles as a campaign list.
 */
import jsonExport from "jsonexport/dist";
import { downloadCSV, type Exporter } from "ra-core";

import type { ZcrmAccount } from "../providers/zinspector/accounts";
import { ACCOUNT_STATUSES } from "../providers/zinspector/crmConfig";
import type { Sale } from "../types";

export const accountExporter: Exporter<ZcrmAccount> = async (
  records,
  fetchRelatedRecords,
) => {
  const managers = await fetchRelatedRecords<Sale>(
    records,
    "account_manager_id",
    "sales",
  );
  const rows = records.map((account) => {
    const manager = account.account_manager_id
      ? managers[account.account_manager_id]
      : undefined;
    return {
      Account: account.name,
      "FileMaker ID": account.accounting_id,
      Status:
        ACCOUNT_STATUSES.find((s) => s.id === account.status)?.label ??
        account.status,
      Market: account.market ?? "",
      "Account kind": account.account_kind,
      "Doors served": account.doors_served,
      "Serviceable doors": account.serviceable_doors,
      "Account manager": manager
        ? `${manager.first_name} ${manager.last_name}`.trim()
        : "",
      "Main contact": account.main_contact_name,
      "Main contact email": account.main_contact_email,
      "Main contact phone": account.main_contact_phone,
      "Office phone": account.office_phone,
      Website: account.website ?? "",
      City: account.city ?? "",
      State: account.state_abbr ?? "",
      "Last touch": account.last_touch?.slice(0, 10) ?? "",
      "Next step": account.next_step,
      "Missing info": account.missing_info.join(", "),
    };
  });
  jsonExport(rows, (_error: Error | null, csv: string) =>
    downloadCSV(csv, "accounts"),
  );
};
